import React from 'react';
import Button from '../../../components/ui/Button';


const PendingTasksCard = ({ tasks }) => {
  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'high':
        return 'text-error';
      case 'medium':
        return 'text-warning';
      case 'low':
        return 'text-success';
      default:
        return 'text-muted-foreground';
    }
  };

  const getPriorityBadge = (priority) => {
    switch (priority) {
      case 'high':
        return 'bg-error/10 text-error';
      case 'medium':
        return 'bg-warning/10 text-warning';
      case 'low':
        return 'bg-success/10 text-success';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden shadow-sm">
      <div className="px-6 py-4 border-b border-border">
        <h2 className="text-lg font-semibold text-foreground">Pending Tasks</h2>
        <p className="text-sm text-muted-foreground mt-1 font-caption">
          Items requiring attention
        </p>
      </div>
      <div className="divide-y divide-border">
        {tasks?.map((task) => (
          <div key={task?.id} className="px-6 py-4 hover:bg-muted/50 transition-colors">
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm font-medium text-foreground">{task?.title}</span>
              <span
                className={`text-xs px-2 py-1 rounded-full font-medium ${getPriorityBadge(
                  task?.priority
                )}`}
              >
                {task?.priority}
              </span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-2xl font-bold text-foreground">{task?.count}</span>
              <Button
                variant="ghost"
                size="sm"
                onClick={task?.action}
                iconName="ArrowRight"
                iconPosition="right"
              >
                Review
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PendingTasksCard;